<template>
  <div>
    <v-card-title
      class="py-2 px-1"
      style="color: var(--v-color-base); word-break: keep-all"
      >{{ productName }}</v-card-title
    >

    <v-card-subtitle class="pa-1">
      <div>{{ productVarSize }}</div>
      <div v-if="showCode">
        <span>
          Code:
          <strong>{{ product.prod_no }}</strong>
        </span>
      </div>

      <div v-if="showSynonym">
        <span>
          Syn:
          <strong>{{ product.prod_synonym }}</strong>
        </span>
      </div>

      <div v-if="/\S/.test(product.country_of_origin) && showCountry">
        <span>
          Country:
          <strong>{{ product.country_of_origin }}</strong>
        </span>
      </div>

      <div v-if="showQtyInBox">
        <span>
          Qty in Box:
          <strong>{{
            product.qty_in_case ? product.qty_in_case : "N/A"
          }}</strong>
           <!-- <strong>{{
            product.qty_in_case ? " / £" + parseFloat(product.box_price/product.qty_in_case).toFixed(2) : ""
          }}</strong> -->
        </span>
      </div>
    </v-card-subtitle>
  </div>
</template>

<script>
export default {
  props: {
    product: {},
  },

  computed: {
    theme() {
      console.log(this.$vuetify.theme);
      return this.$vuetify.theme.dark ? "dark" : "light";
    },

    customStyle() {
      return {
        color: this.$vuetify.theme.themes[this.theme].color,
        // "box-shadow": "0 2px 6px 0 hsla(0, 0%, 0%, 0.2) !important",
        "word-break": "keep-all",
      };
    },

    showCode() {
      return this.$store.getters.retrieveProductCode;
    },

    showSynonym() {
      return this.$store.getters.retrieveProductSynonym;
    },

    showCountry() {
      return this.$store.getters.retrieveProductCountry;
    },

    showQtyInBox() {
      return this.$store.getters.retrieveQtyInBox;
    },

    productName() {
      if (this.$store.getters.retrieveCashDescriptionForAccounts) {
        if (this.product.CsAndCncProductDescription) {
          return this.product.CsAndCncProductDescription;
        } else {
          return this.product.prod_desc;
        }
      } else if (
        (this.$store.getters.retrieveIsCncCustomer &&
          this.product.CsAndCncProductDescription) ||
        (this.$store.getters.retrieveIsCashCustomer &&
          this.product.CsAndCncProductDescription)
      ) {
        return this.product.CsAndCncProductDescription;
      } else {
        return this.product.prod_desc;
      }
    },

    productVarSize() {
      if (
        (this.$store.getters.retrieveIsCncCustomer &&
          this.product.CsAndCncProductDescription) ||
        (this.$store.getters.retrieveIsCashCustomer &&
          this.product.CsAndCncProductDescription)
      ) {
        return null;
      } else {
        let returnString = "";

        if (/\S/.test(this.product.variety)) {
          returnString += this.product.variety;
        }

        if (/\S/.test(this.product.size)) {
          if (returnString != "") {
            returnString += " - ";
          }
          returnString += this.product.size;
        }

        return returnString;
      }
    },
  },
};
</script>

<style lang="sass" scoped>
.v-card__title
  font-size: 14px
  font-weight: bold

.v-card__subtitle
  padding: 4px 1em
</style>